import React from 'react';

export default function ConfirmModal({ open, title, message, onConfirm, onCancel, confirmLabel = 'Yes', cancelLabel = 'No' }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg max-w-sm w-full p-6">
        {title && <h3 className="text-lg font-bold mb-3">{title}</h3>}
        <div className="mb-6 text-gray-800">{message}</div>
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 font-medium"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded bg-amber-500 hover:bg-amber-600 text-black font-bold"
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
